import Layout from '@layouts/Layout';
import Category from '@screens/HelpCenter/Category';

import React, { memo } from 'react';

export const getStaticPaths = async () => {
    let paths = []
    
    try {
        const res = await fetch(`${process.env.NEXT_PUBLIC_APP_URL}/api/v1/support-v2`);
        const data = await res.json();
    
        paths = data.map(category => ({
            params: { category: category.slug }
        }));
    } catch (e) {
        console.log(e)
    }

    return {
        paths: paths,
        fallback: 'blocking'
    };
};

export const getStaticProps = async (context) => {
    const { params } = context;

    const res = await fetch(`${ process.env.NEXT_PUBLIC_APP_URL }/api/v1/support-v2/${ params.category }`);

    if(res.status !== 200)
        return { notFound: true };

    const data = await res.json();

    return {
        props: {
            posts: data['posts'],
            category: data['category']
        },

        revalidate: 60*60*24 // In seconds
    };
};

const CategoryPage = ({ posts, category }) => (
    <Layout
        title={ category?.title }
        description={ category?.description }
        useTitleTemplate='Traqq Help Center'
    >
        <Category
            posts={ posts }
            category={ category }
        />
    </Layout>
);

export default memo(CategoryPage);
